import { Action } from '@ngrx/store';
import { BillsPaginatorInterface } from '../../models/bills.paginator.interface';
import { BillInterface } from '../../models/bill.interface';

export enum EBillsActions {
  GetBills = '[BILL] Get bills',
  GetBillsSuccess = '[BILL] Get bills success',
  GetBillsFailure = '[BILL] Get bills failure',
  DownloadBill = '[BILL] Download bill',
  DownloadFile = '[BILL] Download File',
  DownloadBillSuccess = '[BILL] Download bill success',
  DownloadBillFailure = '[BILL] Download bill failure',
  SetSelectedBill = '[BILL] SetSelectedBill',
}

export class GetBills implements Action {
  public readonly type = EBillsActions.GetBills;
}

export class GetBillsSuccess implements Action {
  public readonly type = EBillsActions.GetBillsSuccess;
  constructor(public payload: BillsPaginatorInterface) {}
}

export class GetBillsFailure implements Action {
  public readonly type = EBillsActions.GetBillsFailure;
}

export class DownloadBill implements Action {
  public readonly type = EBillsActions.DownloadBill;
  constructor(public billingId: number, public filename: string, public mimeType: string) {}
}

export class DownloadBillSuccess implements Action {
  public readonly type = EBillsActions.DownloadBillSuccess;
}

export class DownloadBillFailure implements Action {
  public readonly type = EBillsActions.DownloadBillFailure;
}

export class SetSelectedBill implements Action {
  public readonly type = EBillsActions.SetSelectedBill;
  constructor(public payload?: BillInterface) {}
}

export class DownloadFile implements Action {
  public readonly type = EBillsActions.DownloadFile;
  constructor(public fileId: number, public fileTypeSlug: string, public fileName: string, public mimeType: string) {}
}

export type BillsActions = GetBills | DownloadFile | GetBillsSuccess | GetBillsFailure | DownloadBill | DownloadBillSuccess | DownloadBillFailure | SetSelectedBill;
